import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { first, flatMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
class NgxFreshChatService {
    constructor() { }
    /**
     * Initializes the Freshchat Widget.
     * @param data The Freshchat init object.
     * @returns An Observable which emits when the widget has loaded.
     * @author beyondsanity
     */
    init(data) {
        return this.loadScript('https://wchat.freshchat.com/js/widget.js')
            .pipe(first(), flatMap(res => this.initWidget(data)));
    }
    initWidget(data) {
        return new Observable(observer => {
            this.getWidget().on('widget:loaded', res => observer.next(res));
            this.getWidget().init(data);
        });
    }
    /**
     * Used to capture the user creation event. This can be used to save the restoreID.
     * @returns An Observable which emits when a user is created.
     * @author Will Poulson
     */
    onUserCreate() {
        return new Observable((observer) => {
            this.getWidget().on('user:created', (res) => {
                if (res.status !== 200) {
                    observer.error(res.status);
                }
                else {
                    observer.next(res.data || null);
                }
            });
        });
    }
    /**
     * To check if there are unread messages
     * @returns An Observable which emits the count unread messages.
     * @author wutkaru
     */
    unreadCount() {
        return new Observable((observer) => {
            this.getWidget().on('unreadCount:notify', (res) => {
                observer.next(res.count || null);
            });
        });
    }
    /**
     * Gets the current Freshchat user.
     * @returns An Observable which emits the current user.
     * @author beyondsanity
     */
    getUser() {
        return new Observable(observer => {
            this.getWidget().user.get(res => {
                if (res.status !== 200) {
                    observer.error(res.status);
                }
                else {
                    observer.next(res.data);
                }
            });
        });
    }
    /**
     * Sets the current Freshchat users properties
     * @param user The new properties for the user.
     * @returns An Observable which emits after the user has been updated.
     * @author beyondsanity
     */
    setUserProperties(user) {
        return new Observable(observer => {
            this.getWidget().user.setProperties(user, res => {
                if (res.status !== 200) {
                    observer.error(res.status);
                }
                else {
                    observer.next(res.data || null);
                }
            });
        });
    }
    /**
     * Updates the current Freshchat user.
     * @param user The new properties to update the user with.
     * @author beyondsanity
     */
    updateUser(user) {
        this.getWidget().user.update(user);
    }
    /**
     * Clears the current Freshchat user.
     * @returns An Observable which emits when the user has been cleared.
     * @author beyondsanity
     */
    clearUser() {
        return new Observable(observer => {
            this.getWidget().user.clear(res => {
                if (res.status !== 200) {
                    observer.error(res.status);
                }
                else {
                    observer.next(res.data || null);
                }
            });
        });
    }
    /**
     * Checks whether the Freshchat Widget is open.
     * @author beyondsanity
     */
    isOpen() {
        return this.getWidget().isOpen();
    }
    /**
     * Opens the Freshchat Widget.
     *
     * @param payload Optional - parameters including channel id or name.
     * The replyText parameter can be used to set up custom text in the text area of the widget.
     * @author beyondsanity
     */
    open(payload) {
        this.getWidget().open(payload);
    }
    /**
     * Closes the Freshchat Widget.
     * @author beyondsanity
     */
    close() {
        this.getWidget().close();
    }
    /**
     * Tracks an event against the current user.
     * @param eventName The event name to track.
     * @param payload Optional - The payload to pass to the event.
     * @author beyondsanity
     */
    track(eventName, payload) {
        this.getWidget().track(eventName, payload);
    }
    /**
     * Sets the tags against the current user
     * @param tags An array of tags to set.
     * @author beyondsanity
     */
    setTags(tags) {
        this.getWidget().setTags(tags);
    }
    /**
     * Sets the locale for the current user
     * @param locale The locale.
     * @author beyondsanity
     */
    setLocale(locale) {
        this.getWidget().setLocale(locale);
    }
    /**
     * Destroys the current Freshchat widget.
     * @author beyondsanity
     */
    destroy() {
        this.getWidget().destroy();
    }
    /**
     * Checks if the widget has been initialized
     * @returns A boolean of if the widget has been initialized
     * @author beyondsanity
     */
    isInitialized() {
        return this.getWidget().isInitialized();
    }
    getWidget() {
        return window.fcWidget;
    }
    loadScript(src) {
        return new Observable((observer) => {
            const scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.src = src;
            scriptElement.onload = () => {
                observer.next(src);
                observer.complete();
            };
            scriptElement.onerror = () => observer.error('Couldn\'t load ' + src);
            document.getElementsByTagName('body')[0].appendChild(scriptElement);
        });
    }
}
NgxFreshChatService.ɵfac = function NgxFreshChatService_Factory(t) { return new (t || NgxFreshChatService)(); };
NgxFreshChatService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NgxFreshChatService_Factory() { return new NgxFreshChatService(); }, token: NgxFreshChatService, providedIn: "root" });
NgxFreshChatService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFreshChatService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgxFreshChatModule {
}
NgxFreshChatModule.ɵfac = function NgxFreshChatModule_Factory(t) { return new (t || NgxFreshChatModule)(); };
NgxFreshChatModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxFreshChatModule });
NgxFreshChatModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgxFreshChatService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFreshChatModule, [{
        type: NgModule,
        args: [{
                imports: [],
                providers: [NgxFreshChatService],
                declarations: [],
                exports: []
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-freshchat-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxFreshChatModule, NgxFreshChatService };

